<template>
    <el-form ref="loginForm" auto-complete="on">
        <el-row :style="{marginBottom: '10px', height: '100px'}">
            <el-col :span="24" align="center">
                <img
                    :src="`${$root.storage_url}${$helper.getProp(configs,'LOGO_HIGHLIGHT.data.path')}`"
                    v-if="$helper.getProp(configs,'LOGO_HIGHLIGHT.data.path')"
                    alt
                    height="100"
                />
            </el-col>
        </el-row>
    </el-form>
</template>
<script>
export default {
    name: 'verify-data-form',
    created() {
        if (!this.$route.query.token) {
            this.$router.push(
                '/something-went-wrong?message=Token/OTP not found.',
                () => {
                    this.$message.error('Token/OTP not found.');
                }
            );
        } else {
            const loading = this.$loading({
                lock: true,
                text: 'Verifying...'
            });
            this.axios
                .post('data-verify', {
                    token: this.$route.query.token
                })
                .then(response => {
                    loading.close();
                    this.$router.push('/token-verify/success', () => {
                        this.$message.success(
                            'Email/Mobile no. has been verified successfully.'
                        );
                    });
                })
                .catch(() => {
                    loading.close();
                    this.$router.push(
                        '/something-went-wrong?message=Link has become invalid.',
                        () => {
                            this.$message.error('Link has become invalid.');
                        }
                    );
                });
        }
    }
};
</script>
